import React from 'react';
import { useRouter } from 'next/router';
import { Company } from '../../models';

interface MarcaProps {
  allies: Company[];
  allyId: string;
  setAllyId: React.Dispatch<React.SetStateAction<string>>;
}

function Marca({ allies, allyId, setAllyId }: MarcaProps) {
  const router = useRouter();

  React.useEffect(() => {
    if (router.query.allyQueryParam) {
      setAllyId(router.query.allyQueryParam as string);
    }
  }, []);
  return (
    <div className="w-full flex flex-col gap-5">
      <p className="text-neutral-cold-800 lg:text-lg text-xl text-left font-semibold">
        Marca
      </p>
      <div className="w-full flex flex-row lg:flex-col gap-3 whitespace-nowrap px-5 lg:max-h-[50vh] overflow-auto">
        {allies?.map((ally, index) => (
          <button
            key={index}
            type="button"
            className="flex-shrink-0 inline-block bg-meitWhite bg-no-repeat bg-right rounded-lg overflow-clip shadow-md mb-2 w-[50%] lg:w-[95%]"
            onClick={(e) => {
              e.preventDefault();
              if (ally?._id !== allyId) {
                setAllyId(ally?._id);
              } else {
                setAllyId('');
              }
            }}
          >
            <div
              className={`w-[175px] lg:w-[250px] h-14 flex items-center text-left text-black font-medium px-5 ease-in-out duration-150 ${
                ally?._id === allyId
                  ? 'text-white bg-gradient-to-r from-purple-300 via-purple-200 to-transparent'
                  : 'hover:text-white bg-gradient-to-r from-system-100 via-system-100 hover:from-purple-100 hover:via-purple-50 to-transparent'
              }`}
            >
              {ally?.name}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

export default Marca;
